<template>
  <ModalBase
    name="cv-upload-sales"
  >
    <h3 class="modaltitle">Poďme na to!</h3>

    <div v-if="isSent">
      Ďakujeme, formulár bol odoslaný!
    </div>

    <form @submit.prevent="submit()" v-else>
      <div class="form-group">
        <label class="form-label">Okres</label>
        <select class="form-control" v-model="county" required>
          <option value="" selected disabled>Prosím, vyberte</option>
          <option
            v-for="county in counties"
            :key="county.name"
            :value="county.name"
          >
            {{ county.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">Meno a priezvisko</label>
        <input type="text" class="form-control" v-model="name" required>
      </div>
      <div class="form-group">
        <label class="form-label">Email (nepovinné)</label>
        <input type="email" class="form-control" v-model="email">
      </div>
      <div class="form-group">
        <label class="form-label">Telefón</label>
        <input type="text" class="form-control" v-model="phone" required>
      </div>
      <div class="form-group">
        <label class="form-label">Tvoje CV (nepovinné)</label>
        <FileInput
          v-model="file"
        />
      </div>
      <ButtonPrimary size="small" type="submit" :disabled="isSending">
        Odoslať
      </ButtonPrimary>
    </form>

  </ModalBase>
</template>

<script>
import axios from 'axios';
import counties from '@/data/counties.json';

import ModalBase from '@/components/ModalBase.vue';
import ButtonPrimary from '@/components/ButtonPrimary.vue';
import FileInput from '@/components/FileInput.vue';

export default {
  components: {
    ModalBase,
    ButtonPrimary,
    FileInput,
  },
  data() {
    return {
      isSending: false,
      isSent: false,
      name: '',
      email: '',
      phone: '',
      file: '',
      county: '',
      counties,
    };
  },
  computed: {
    formRecipient() {
      const directors = {
        BA: 'miroslav.sedmak@wuestenrot.sk',
        TT: 'miroslav.sedmak@wuestenrot.sk',
        TN: 'lucia.hornickova@wuestenrot.sk',
        NR: 'peter.sabo@wuestenrot.sk',
        BB: 'jan.tesar@wuestenrot.sk',
        ZA: 'milos.ernihold@wuestenrot.sk',
        KE: 'jana.bic@wuestenrot.sk',
        PO: 'vladimir.lesko@wuestenrot.sk',
      };
      const selectedCounty = counties.find(
        (county) => county.name === this.county,
      );
      if (selectedCounty) {
        return directors[selectedCounty.region];
      }
      return null;
    },
  },
  methods: {
    async submit() {
      this.isSending = true;
      const data = {
        name: this.name,
        phone: this.phone,
        region: this.county,
      };
      if (this.formRecipient) {
        data.recipient = this.formRecipient;
      }
      if (this.email) {
        data.email = this.email;
      }
      if (this.file) {
        data.mime = 'application/pdf';
        data.cv = this.file;
      }
      await axios({
        method: 'post',
        url: 'https://wusapi.thread.sk/api/v1/career/cv',
        headers: { Accept: 'application/json' },
        data,
      });
      this.isSending = false;
      this.isSent = true;
      // this.$modal.hide('cv-upload-sales');
    },
  },
};
</script>
